import React from "react";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/sagas/utilization";

export const GroupByFilter = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.utilization.groupByFilterOption);
  const selectedFilters = useSelector((state) => state.utilization.selectedGroupByFilterOption);

  const groupByFilterSettings = {
    options,
    selectedFilters,
    placeholder: "Select Group by",
    numberDisplayed: 0
  };

  const onSelectChange = (data) => {
    dispatch(actionCreators.updateGroupBy(data));
  };

  return <MultiSelectDropdown {...groupByFilterSettings} onSelectChange={onSelectChange} />;
};
